exports.simmelianStrength = require('./simmelian-strength.js');
